export const vendortableColumns = [
  {
    id: "S.No",
    label: "S.No",
    minWidth: 70,
    align: "left",
  },
  {
    id: "createdAt",
    label: "Onboarding Date",
    minWidth: 150,
    align: "left",
  },
  {
    id: "fullName",
    label: "Full Name",
    minWidth: 150,
    align: "left",
  },
  {
    id: "email",
    label: "Email",
    minWidth: 70,
    align: "left",
  },
  {
    id: "mobileNumber",
    label: "Phone Number",
    minWidth: 150,
    align: "left",
  },
  {
    id: "mobileNumber",
    label: "Current Subscription",
    minWidth: 200,
    align: "left",
  },
  {
    id: "mobileNumber",
    label: "Subscription Expiry",
    minWidth: 200,
    align: "left",
  },
  {
    id: "isActive",
    label: "Active",
    minWidth: 70,
    align: "center",
  },
  {
    id: "action",
    label: "Action",
    minWidth: 100,
    align: "center",
  },
];
